import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      name: 'ES',
      country: i18n.t('DIRe_prefix.ES')
    },
  ]
}

export function DIRE_PREFIX (state) {
  return configHelper.getConfig(state, 'DIRE_PREFIX', GenerateConfig)
}
